var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMappa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_3361",
    "data-name": "Rettangolo 3361",
    width: 24,
    height: 24,
    fill: "#a9a9a9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Mappa1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mappa1",
    clipPath: "url(#clip-Mappa1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_32918",
    "data-name": "Raggruppa 32918",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_32917",
    "data-name": "Raggruppa 32917",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_26731",
    "data-name": "Tracciato 26731",
    d: "M20.854.736,16.438.013a.818.818,0,0,0-.121.006A.73.73,0,0,0,16.224,0a1.019,1.019,0,0,0-.146.029c-.016,0-.034,0-.05,0l-.143.037a.527.527,0,0,0-.057.014l-8.151,2.1L4.355,1.636a3.713,3.713,0,0,0-.605-.049A3.754,3.754,0,0,0,0,5.337V19.563a3.735,3.735,0,0,0,3.146,3.7l4.416.723A.962.962,0,0,0,7.723,24c.011,0,.022,0,.032,0s.014,0,.021,0a.9.9,0,0,0,.09-.018.962.962,0,0,0,.106-.014l.144-.037a.573.573,0,0,0,.056-.014l8.151-2.1,3.318.542c.2.034.39.035.609.05A3.754,3.754,0,0,0,24,18.663V4.437a3.736,3.736,0,0,0-3.146-3.7M8.776,3.962,15.224,2.3V20.039L8.776,21.7ZM2,19.563V5.337a1.752,1.752,0,0,1,1.75-1.75,1.781,1.781,0,0,1,.283.023l2.743.448V21.831L3.468,21.29A1.743,1.743,0,0,1,2,19.563m20-.9a1.753,1.753,0,0,1-1.753,1.75c-.089-.006-.186-.008-.281-.023l-2.742-.448V2.168l3.308.542A1.744,1.744,0,0,1,22,4.437Z",
    fill: "#a9a9a9"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMappa);
export default __webpack_public_path__ + "static/media/Mappa.92cc1d111f9f4da4e5728fc961ac16a9.svg";
export { ForwardRef as ReactComponent };